import { IonToolbar, IonTitle, IonButtons, IonButton } from '@ionic/react'

type Props = {
  onFinish: () => void
  title?: string
}

function CheckInLoyaltyHeader({ onFinish, title = 'Redeem Rewards' }: Props) {
  return (
    <IonToolbar>
      <IonTitle>{title}</IonTitle>
      <IonButtons slot="end">
        <IonButton color="yellow" fill="solid" onClick={onFinish}>
          Finish
        </IonButton>
      </IonButtons>
    </IonToolbar>
  )
}

export { CheckInLoyaltyHeader }
